import { action, observable } from 'mobx';
import { cloneDeep } from 'lodash';

import { SetupStore } from './SetupStore';
import appStore from '../../../core/stores/AppStore';

export class SetupStoreNoProfile extends SetupStore {
  @observable
  details_locked: boolean;
  @observable
  details_collapsed: boolean;
  @observable isUnpinned: boolean;

  constructor(serviceContainer: any) {
    super(serviceContainer);
    this.details_locked = true;
    this.details_collapsed = false;
    this.isUnpinned = false;
    appStore.setLayoutOnWindowsResize(this);
  }

  @action
  updateDetailsLockedForm = () => {
    this.setIsUnpinned(!this.isUnpinned);
    this.details_locked = !this.details_locked;
  };

  @action
  setIsUnpinned(value: boolean) {
    this.isUnpinned = value;
  }

  @action setDetailsLocked = (value: boolean) => {
    this.details_locked = value;
  };

  @action setDetailsCollapsed = (value: boolean) => {
    this.details_collapsed = value;
  };

  @action toggleDetailsCollapsed = () => {
    this.setDetailsCollapsed(!this.details_collapsed);
  };

  @action toggleDetailsLocked = () => {
    this.updateDetailsLockedForm();
    if (!this.details_locked) {
      this.setDrawerOpen(true);
    } else {
      this.setDrawerOpen(false);
    }
  };

  addFirstElementIntoList = async (element: any, notSetElement?: boolean) => {
    this.setSuppressOrdering(true);
    const items: any[] = cloneDeep(this.elements);
    items.unshift(element);
    this.setElements(items);
    this.setCount(items.length);
    !notSetElement && (await this.setElementById(element.id));
  };
}
